// extracted by mini-css-extract-plugin
export default {"tag":"ExpirationDateTag_tag__-OzCU"};